"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _feBrary = require("@domain-group/fe-brary");
var _default = "\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ".concat(_feBrary.variables.global.layerOverlay, ";\n\n  li {\n    display: inline-block;\n    margin: 3px;\n  }\n\n  button {\n    display: block;\n    width: 10px;\n    height: 10px;\n    padding: 0;\n    border: 1px solid ").concat(_feBrary.variables.colour.white, ";\n    background: none;\n    font-size: 0;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  .slick-active button {\n    background: ").concat(_feBrary.variables.colour.white, ";\n  }\n");
exports.default = _default;